import { CONVERTIBLE_NOTES, UNISSUED_OPTIONS } from 'common/constants/securityTypes';
import { CapTableInfo } from 'common/types/capTable';

const getValidSecurities = (captableObject: CapTableInfo) => {
  if (typeof captableObject !== 'object' || !Object.keys(captableObject).includes('securities')) {
    return [];
  }

  return captableObject.securities?.filter(s => ![UNISSUED_OPTIONS, CONVERTIBLE_NOTES].includes(s.security_type!)).sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
 ?? [];
};

export default getValidSecurities;
